import { render, staticRenderFns } from "./home-main.vue?vue&type=template&id=641a3dd6&"
import script from "./home-main.vue?vue&type=script&lang=js&"
export * from "./home-main.vue?vue&type=script&lang=js&"
import style0 from "./home-main.vue?vue&type=style&index=0&id=641a3dd6&prod&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports